






import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class EstimateRow extends Vue {
  @Prop({ type: Boolean }) draggable!: boolean;

  get style() {
    return {
      "grid-template-columns":
        "1fr 9rem 3rem 4rem 6rem 6rem 6rem 6rem 4rem 1fr 2rem 2rem"
    };
  }
}
